// extracted by mini-css-extract-plugin
export var cardItem = "CardItem-module--cardItem--72543";
export var cardItem__desc = "CardItem-module--cardItem__desc--bdf71";
export var cardItem__footer = "CardItem-module--cardItem__footer--f5e9e";
export var cardItem__footerItem = "CardItem-module--cardItem__footerItem--8fc36";
export var cardItem__img = "CardItem-module--cardItem__img--fe47a";
export var cardItem__linkArrow = "CardItem-module--cardItem__linkArrow--5dfdf";
export var cardItem__rightSide = "CardItem-module--cardItem__rightSide--4c677";
export var cardItem__subtitle = "CardItem-module--cardItem__subtitle--454ae";
export var cardItem__title = "CardItem-module--cardItem__title--70c04";
export var cardItem__titleAndDate = "CardItem-module--cardItem__titleAndDate--5e2d0";